import { BaseConfigType } from 'config';
import getConfig from 'next/config';

const { publicRuntimeConfig = { config: {} } } = getConfig() || {
  publicRuntimeConfig: { config: require('../config/default').default },
};
export default publicRuntimeConfig.config as BaseConfigType;
